<template>
	<div :class="customClass" :style="customStyle">
		<div :class="titleClass" :style="titleStyle">
			{{ titleText }}
		</div>

		<div :class="[timeClass, { 'text-[#F35610]': isWarning }]" :style="timeStyle">
			{{ formattedTime }}
		</div>

		<div :class="bottomTextClass" :style="bottomTextStyle">
			{{ bottomText }}
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
const isWarning = ref(false);
const props = defineProps({
	deadline: { type: Date, required: true },

	titleText: { type: String, default: "TIME TO DEADLINE" },
	bottomText: { type: String, default: "TIME TO DEADLINE" },

	// Classes/Styles from parent
	customClass: { type: String, default: "" },
	customStyle: { type: Object, default: () => ({}) },

	titleClass: { type: String, default: "" },
	titleStyle: { type: Object, default: () => ({}) },

	timeClass: { type: String, default: "" },
	timeStyle: { type: Object, default: () => ({}) },

	bottomTextClass: { type: String, default: "" },
	bottomTextStyle: { type: Object, default: () => ({}) },
});

const formattedTime = ref("");
let intervalId;

const updateCountdown = () => {
	const now = new Date();
	const diff = props.deadline - now;

	if (diff <= 0) {
		formattedTime.value = "00:00:00";
		clearInterval(intervalId);
		isWarning.value = true;
	} else {
		const hours = Math.floor(diff / (1000 * 60 * 60));
		const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((diff % (1000 * 60)) / 1000);

		formattedTime.value = `${String(hours).padStart(2, "0")}:${String(
			minutes
		).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

		isWarning.value = diff <= 10 * 60 * 1000; // 10 minutes or less
	}
};


onMounted(() => {
	updateCountdown();
	intervalId = setInterval(updateCountdown, 1000);
});

onUnmounted(() => {
	clearInterval(intervalId);
});
</script>
